
import { PROFICIENCY_LIST_COUNT } from '../../../settings.js'
import connector from '../../connector.js'

/**
 * Get Testable
 * @param {Object} options
 * @param {number} options.id Testable ID
 */
export function get ({ id }) {
  return connector.get(`proficiency/testable/${id}`).json()
}

/**
 * Get Testable list
 * @param {Object} filter Filter options
 * @param {string} filter.search Search term
 * @param {number} filter.offset Offset value
 * @param {number} [filter.limit=100] Number of results
 * @param {import('ky').Options} [options] Request options
 */
export function getList ({ search, offset, limit = PROFICIENCY_LIST_COUNT }, options) {
  const searchParams = { limit, search, offset }
  return connector.get('proficiency/testable', { searchParams, ...options }).json()
}

/**
 * Create new Testable
 * @param {Object} options
 * @param {Object} options.data Testable data
 */
export function create ({ data }) {
  return connector.post('proficiency/testable', data).json()
}

/**
 * Update existing Testable
 * @param {Object} options
 * @param {number} options.id Testable ID
 * @param {Object} options.data Testable data
 */
export function update ({ id, data }) {
  return connector.patch(`proficiency/testable/${id}`, data).json()
}

/**
 * Remove Testable
 * @param {Object} options
 * @param {number} options.id Testable ID
 */
export function remove ({ id }) {
  return connector.delete(`proficiency/testable/${id}`).json()
}

export function preflight (id) {
  return connector.get(`proficiency/testable/${id}/delete-preflight`).json()
}
